<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="88.951" height="106.027" viewBox="427.323 791.986 88.951 106.027">
        <path
            d="M475.357 815.103h29.65l3.706 3.853v15.642h3.855l3.706 3.852v7.475l-3.706 3.852h-3.855v23.117l-3.706 3.853H481.88l-18.532 21.267-6.374-2.774v-18.493h-18.532l-3.706-4.932v-22.038h-3.706l-3.707-3.852v-7.475l3.707-3.852h3.706v-16.721l3.929-2.774h29.65v-8.784c-2.366-1.309-3.868-3.842-3.929-6.627 0-4.256 3.319-7.706 7.413-7.706s7.412 3.45 7.412 7.706c-.124 2.685-1.584 5.108-3.854 6.395v9.016Zm26.092 30.822v-23.117h-59.3v45.154l18.531 1.08h3.706v16.874l13.343-15.72 2.594-1.155h21.126v-23.116Zm-15.715 3.93c-2.775 2.892-6.306 4.874-10.155 5.702v-.078c-6.518 1.297-13.232-.837-17.938-5.702l-5.189 5.471a26.784 26.784 0 0 0 8.821 6.088 26.973 26.973 0 0 0 10.526 2.234c7.166-.045 14.03-3.005 19.124-8.245l-5.189-5.47Zm-25.128-15.489h-7.413v7.706h7.413v-7.706Zm22.237 0h7.413v7.706h-7.413v-7.706Z"
            fill="#ec4b1d"
            fill-rule="evenodd"
            data-name="hubot-svgrepo-com"
        />
    </svg>
</template>
<script>
export default {
    name: "CChatbot",
};
</script>
